var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 112,
    viewBox: "0 0 113 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 6135"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2083",
    x: 16.5,
    y: 34,
    width: 80,
    height: 52,
    fill: "#104239"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.5 56C0.5 25.0688 25.5688 0 56.5 0C87.4312 0 112.5 25.0688 112.5 56C112.5 86.9312 87.4312 112 56.5 112C25.5688 112 0.5 86.9312 0.5 56ZM81.8312 46.3312C84.2156 43.9469 84.2156 40.0531 81.8312 37.6688C79.4469 35.2844 75.5531 35.2844 73.1688 37.6688L49.5 61.3375L39.8312 51.6688C37.4469 49.2844 33.5531 49.2844 31.1687 51.6688C28.7844 54.0531 28.7844 57.9469 31.1687 60.3312L45.1688 74.3312C47.5531 76.7156 51.4469 76.7156 53.8312 74.3312L81.8312 46.3312Z",
    fill: "#F6EFDF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.feb0337bae9b6167bf65922d046f8547.svg";
export { ForwardRef as ReactComponent };